import api from '../../utils/api'

const API_BASE_URL = "/ast/ASTQr";

const ASTQrService = {
  async findAll(recordFilter: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`, {
      params: recordFilter,
    });
    return response.data;
  },

  async getItemById(qrBatchId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${qrBatchId}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(qrBatchId: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${qrBatchId}`, item);
    return response.data;
  },

  async delete(qrBatchId: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${qrBatchId}`);
    return response.data;
  },

};

export default ASTQrService;